import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { DataSource } from './data-source';
import { Principal } from '../auth/principal.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DataSourceService {
    private _dataSources: { [key:string]: DataSource<any> } = {};
    private _dataSources_enableCache: { [key:string]: DataSource<any> } = {};

    constructor(
        private http: HttpClient,
        private principal: Principal
    ) {
        this.principal.authenticationStateChange.subscribe(account=>{
            this._dataSources = {};
            this._dataSources_enableCache = {};
        });
    }

    getDataSource(apiUrl: string, serviceBaseUrl?: string, enableCache?:boolean): DataSource<any>{
	let url = serviceBaseUrl?serviceBaseUrl+apiUrl:apiUrl;
        if(!url || url.length == 0){
            console.error("DataSourceService.getDataSource error: param url is required!");
            return null;
        }
        
        let dataSource = enableCache?this._dataSources_enableCache[url]:this._dataSources[url];
        if(dataSource == null){
            dataSource = new DataSource<any>(this.http, url, enableCache);
            if(enableCache) this._dataSources_enableCache[url] = dataSource;
            else this._dataSources[url] = dataSource;
        }
        return dataSource;
    }

    post(apiUrl:string, data: any, params?: { [param: string]: any | any[] }): Observable<HttpResponse<any>> {
        return this.getDataSource(apiUrl).post(data, params);
    }
    put(apiUrl:string, data: any, params?: { [param: string]: any | any[] }): Observable<HttpResponse<any>> {
        return this.getDataSource(apiUrl).put(data, params);
    }
    query(apiUrl:string, params?: { [param: string]: any | any[] }): Observable<HttpResponse<any>> {
        return this.getDataSource(apiUrl).query( params);
    }
}
